import { render, staticRenderFns } from "./modal-steps.vue?vue&type=template&id=2a1785f7&"
import script from "./modal-steps.vue?vue&type=script&lang=js&"
export * from "./modal-steps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports